import React from 'react';
import useStyles from './Faq.styles';
import {ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography} from '@material-ui/core';
import ExpandMoreIcon from 'mdi-material-ui/ChevronDown';

export default function ({title, children}) {
    let classes = useStyles();

    return (
        <ExpansionPanel
            classes={{
                root: classes['root'],
            }}
        >
            <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                classes={{
                    root: classes['__faq'],
                    content: classes['__faq-content'],
                    expandIcon: classes['__faq-icon'],
                }}
            >
                <Typography
                    className={classes['__faq-title']}
                    variant="h5"
                    component="h2"
                >
                    {title}
                </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails classes={{root: classes['__content']}}>
                {children}
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );
};
